const blogPosts = [
  {
    slug: 'cicd-transformation-75-percent-faster-releases',
    day: '15',
    month: 'Jan',
    image: require('@/assets/images/blog_cicd_transformation.svg'),
    alt: 'CI/CD Transformation with Jenkins and ArgoCD pipeline diagram',
    title: 'CI/CD Transformation: Achieving 75% Faster Releases with Jenkins and ArgoCD',
    excerpt: 'How we transformed our CI/CD architecture using AWS CodePipeline, Jenkins, and ArgoCD to achieve 75% faster releases and 40% fewer deployment errors across our R&D division.'
  },
  {
    slug: 'kubernetes-migration-at-scale',
    day: '10',
    month: 'Dec',
    image: require('@/assets/images/blog_kubernetes_migration.svg'),
    alt: 'Kubernetes migration from legacy infrastructure to containerized clusters',
    title: 'Migrating 90% of Legacy Apps to Kubernetes: Lessons Learned',
    excerpt: 'A deep dive into the container migration journey that achieved 50% better scalability and $150K in annual savings through strategic Kubernetes adoption.'
  },
  {
    slug: 'terraform-iac-platform-unification',
    day: '5',
    month: 'Nov',
    image: require('@/assets/images/blog_terraform_iac.svg'),
    alt: 'Terraform Infrastructure as Code platform across multi-cloud environments',
    title: 'Unifying Infrastructure as Code with Terraform Across 50+ Environments',
    excerpt: 'Building a unified IaC platform with Terraform that enabled 4x faster provisioning and 30% fewer incidents across hybrid cloud environments.'
  },
  {
    slug: 'devsecops-sast-dast-integration',
    day: '20',
    month: 'Oct',
    image: require('@/assets/images/blog_devsecops_sast_dast.svg'),
    alt: 'DevSecOps SAST and DAST security integration in CI/CD pipeline',
    title: 'Implementing DevSecOps: SAST/DAST in CI/CD Pipelines',
    excerpt: 'How championing DevSecOps practices with SonarQube and Twistlock led to 35% fewer vulnerabilities while mentoring a team of 10+ engineers.'
  },
  {
    slug: 'aws-cloud-cost-optimization-strategies',
    day: '8',
    month: 'Sep',
    image: require('@/assets/images/blog_aws_cost_optimization.svg'),
    alt: 'AWS cloud cost optimization showing savings trends and strategies',
    title: 'AWS Cloud Cost Optimization: Achieving 20-35% Savings',
    excerpt: 'Practical strategies for cloud cost optimization using reserved instances, right-sizing, and AWS Cost Explorer to achieve significant cost reductions.'
  },
  {
    slug: 'gitops-innovation-1m-revenue-impact',
    day: '1',
    month: 'Aug',
    image: require('@/assets/images/blog_gitops_innovation.svg'),
    alt: 'GitOps innovation with Kubernetes generating $1M in revenue',
    title: 'GitOps Innovation: How a Kubernetes Project Generated $1M in Revenue',
    excerpt: 'The story behind the Transform Collaborate Partner Award - leading a Kubernetes GitOps project that secured a new client and generated $1M in revenue.'
  }
]

export default blogPosts
